"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractAppHost_1 = require("./AbstractAppHost");
var mobx_1 = require("mobx");
var mobx_2 = require("mobx");
var PathUtils = require("../PathUtils");
var qs = require("qs");
var StringUtils_1 = require("../StringUtils");
var Defaults = {
    windowAppHostKey: "__app_host_dodgy_global__",
    resolveHostMaxWait: 20000,
    resolvePollInterval: 120
};
exports.Defaults = Defaults;
var BrowserAppHost = /** @class */ (function (_super) {
    __extends(BrowserAppHost, _super);
    function BrowserAppHost() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onPopState = function (e) {
            _this.setRequest(_this.defaultRequest);
            _this._loadImpl();
        };
        return _this;
    }
    Object.defineProperty(BrowserAppHost.prototype, "root", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserAppHost.prototype, "extension", {
        get: function () {
            return this._extension;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserAppHost.prototype, "window", {
        get: function () {
            return this._window;
        },
        set: function (value) {
            this.setWindow(value);
        },
        enumerable: true,
        configurable: true
    });
    BrowserAppHost.prototype.setWindow = function (value) {
        this._window = value;
        if (value) {
            value[Defaults.windowAppHostKey] = this;
        }
    };
    Object.defineProperty(BrowserAppHost.prototype, "publicPath", {
        get: function () {
            return this._publicPath;
        },
        set: function (value) {
            this.setPublicPath(value);
        },
        enumerable: true,
        configurable: true
    });
    BrowserAppHost.prototype.setPublicPath = function (publicPath) {
        this._publicPath = publicPath;
    };
    BrowserAppHost.prototype.setTitle = function (title) {
        _super.prototype.setTitle.call(this, title);
        this.window.document.title = title;
    };
    BrowserAppHost.prototype.getUrl = function (request) {
        var url = PathUtils.join(PathUtils.sep, this.publicPath, request && request.path ? request.path : this.path);
        if (this._extension) {
            url += this._extension;
        }
        var queryString;
        if (request && request.query) {
            queryString = qs.stringify(request.query);
        }
        if (queryString) {
            url += "?" + queryString;
        }
        return url;
    };
    BrowserAppHost.prototype.setInitialized = function (initialized) {
        this._initialized = initialized;
        if (!initialized) {
            this.clearRequest();
            this.window.removeEventListener("popstate", this._onPopState);
        }
    };
    Object.defineProperty(BrowserAppHost.prototype, "locationPath", {
        get: function () {
            var path = this.window.location.pathname;
            if (this.publicPath) {
                var publicPath = StringUtils_1.stripRight(this.publicPath, PathUtils.sep);
                var publicPathIdx = path.indexOf(publicPath);
                if (publicPathIdx >= 0) {
                    path = path.substring(publicPathIdx + publicPath.length);
                }
            }
            var extension = PathUtils.extname(path);
            if (extension) {
                path = path.substring(0, path.length - extension.length);
            }
            return path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserAppHost.prototype, "locationQuery", {
        get: function () {
            var search = this.window.location.search;
            return search && search.length > 1 ? qs.parse(search.substring(1)) : {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserAppHost.prototype, "locationRequest", {
        get: function () {
            return { path: this.locationPath, query: this.locationQuery };
        },
        enumerable: true,
        configurable: true
    });
    BrowserAppHost.prototype._pushHistory = function (url) {
        this.window.history.pushState({ id: this.id }, null, url);
    };
    BrowserAppHost.prototype._init = function (request) {
        this._extension = PathUtils.extname(this.window.location.pathname);
        this.window.addEventListener("popstate", this._onPopState);
        return _super.prototype._init.call(this, request);
    };
    BrowserAppHost.prototype.open = function (request) {
        var url = this.getUrl(request);
        var newWindow = this.window.open(url, request ? request.windowName : undefined, request ? request.windowFeatures : undefined);
        return new Promise(function (resolve, reject) {
            var interval;
            var startTs = new Date().getTime();
            interval = setInterval(function () {
                var newHost = newWindow[Defaults.windowAppHostKey];
                if (newHost) {
                    resolve(newHost);
                    clearInterval(interval);
                }
                var currentTs = new Date().getTime();
                if (currentTs - startTs > Defaults.resolveHostMaxWait) {
                    clearInterval(interval);
                    reject("Unable to get new app host instance");
                }
            }, Defaults.resolvePollInterval);
        });
    };
    BrowserAppHost.prototype.close = function () {
        this.window.close();
    };
    BrowserAppHost.prototype.addEventListener = function (type, handler) {
        this.window.addEventListener(type, handler);
    };
    BrowserAppHost.prototype.removeEventListener = function (type, handler) {
        this.window.removeEventListener(type, handler);
    };
    BrowserAppHost.prototype.emit = function (event) {
        this.window.dispatchEvent(event);
    };
    Object.defineProperty(BrowserAppHost.prototype, "defaultRequest", {
        get: function () {
            return this.locationRequest;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.action
    ], BrowserAppHost.prototype, "setTitle", null);
    __decorate([
        mobx_1.action
    ], BrowserAppHost.prototype, "setInitialized", null);
    __decorate([
        mobx_1.action
    ], BrowserAppHost.prototype, "_onPopState", void 0);
    __decorate([
        mobx_2.computed
    ], BrowserAppHost.prototype, "defaultRequest", null);
    return BrowserAppHost;
}(AbstractAppHost_1.AbstractAppHost));
exports.BrowserAppHost = BrowserAppHost;
